var map = {
	"./icon_bg_currency.png": "nzOx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TGHy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/icon_.*\.png$
// module id = TGHy
// module chunks = 1